export function getVideoPosterUrl(video) {
  if (video.poster === null || typeof video.poster === 'undefined') {
    return ''; // TODO: Retourner une image de placeholder
  }

  if (video.poster.startsWith('http')) {
    return video.poster;
  }

  return process.env.VUE_APP_API + '/files/uploads/video/posterFile/' + video.poster;
}

export function getReadableViews(video) {
  // Nine Zeroes for Billions
  return Math.abs(Number(video.totalViews)) >= 1.0e+9

      ? Math.abs(Number(video.totalViews)) / 1.0e+9 + "B"
      // Six Zeroes for Millions 
      : Math.abs(Number(video.totalViews)) >= 1.0e+6

      ? Math.abs(Number(video.totalViews)) / 1.0e+6 + "M"
      // Three Zeroes for Thousands
      : Math.abs(Number(video.totalViews)) >= 1.0e+3

      ? Math.abs(Number(video.totalViews)) / 1.0e+3 + "K"

      : Math.abs(Number(video.totalViews));
}